import {defaultAxios} from "../base";

interface IFetchHouseDtl {
    preRequestDtlNo: number;
}

// 주담대 가심사 결과 상품 상세
export const fetchHousePreDtl = async (params:IFetchHouseDtl) => {
    return await defaultAxios().post('/house/cust/preDtl', params);
}